/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>优惠券管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="">
        <el-input size="small" v-model="formInline.name" placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.phoneNumber" placeholder="输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="" v-if="driverlineList!=''&&driverlineList!=null">
        <el-select size="small"  clearable  v-model="formInline.fixId" placeholder="选择隶属线路">
          <el-option
            v-for="item in driverlineList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit2()">手机号发放</el-button>

      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="userData"  v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column align="center"  prop="name" label="优惠券名称" width="120">
      </el-table-column>
      <el-table-column align="center"  prop="rule" label="优惠券类型" width="120">
      </el-table-column>
      <el-table-column align="center"  prop="amount" label="优惠券折扣(分)" width="120">
      </el-table-column>
      <el-table-column align="center"  prop="illustrate" label="使用限制" width="150">
      </el-table-column>
      <el-table-column align="center"  prop="limitations" label="使用说明" width="190">
      </el-table-column>
      <el-table-column  label="操作" min-width="200">
        <template slot-scope="scope">
<!--          <el-button size="mini" type="text" @click="detailUser(scope.$index, scope.row)">查看详情</el-button>-->
          <el-button size="mini" type="danger"  @click="deleteUser(scope.$index, scope.row)">删除</el-button>
          <el-button size="mini"  @click="handleEdit(scope.$index, scope.row)">发放</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="110px" ref="editForm" :model="editForm" :rules="rules" v-if="isUpdate==false">
        <el-form-item label="优惠券名称" prop="name">
          <el-input size="small" v-model="editForm.name" clearable maxlength="11" type="text" auto-complete="off" placeholder="请输入优惠券名称"></el-input>
        </el-form-item>
        <el-form-item label="优惠券类型" prop="rule">
          <el-select size="small" v-model="editForm.rule" clearable placeholder="请选择优惠券类型">
            <el-option label="通用" value="通用"></el-option>
            <el-option label="满减" value="满减"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通用金额/元" prop="amount">
          <el-input size="small" v-model="editForm.amount" type="number" clearable maxlength="3" auto-complete="off" placeholder="请输入通用金额"></el-input>
        </el-form-item>
        <el-form-item label="使用限制" prop="limitations">
          <el-select size="small" v-model="editForm.limitations" auto-complete="off" clearable placeholder="请选择使用限制">
            <el-option label="通用" value="通用"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用说明" prop="illustrate" >
          <el-input size="small" v-model="editForm.illustrate" clearable maxlength="120" auto-complete="off"  type="text" placeholder="请输入使用说明"></el-input>
        </el-form-item>

      </el-form>
      <el-form label-width="110px" ref="editForm" :model="editForm" :rules="rules" v-else>

        <el-form-item label="发放用户" prop="distribute">
          <el-select size="small" v-model="editForm.distribute" clearable placeholder="请选择优惠券类型">
            <el-option label="全部用户" value="1"></el-option>
            <el-option label="老用户" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发放时间"  prop="effective">
          <el-date-picker
            v-model="editForm.effective"
            clearable
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>


    <el-dialog :title="title" :visible.sync="coupouVisible" width="30%" @click='closeDialog("coupouEdit")'>
      <el-form label-width="150px" ref="editForm" :model="editForm" :rules="rules" >
        <el-form-item label="用户手机号" prop="userPhone">
          <el-input size="small" v-model="editForm.userPhone" clearable maxlength="11" type="number" auto-complete="off" placeholder="请输入用户手机号"></el-input>
        </el-form-item>
        <el-form-item label="通用金额(单位/分)" prop="denom">
          <el-input size="small" v-model="editForm.denom" type="number" clearable maxlength="5" auto-complete="off" placeholder="请输入通用金额"></el-input>
        </el-form-item>
        <el-form-item label="使用类型" prop="type" >
          <el-input size="small" v-model="editForm.type" clearable maxlength="120" auto-complete="off"  type="text" placeholder="请输入使用类型"></el-input>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("coupouEdit")'>取消</el-button>
        <el-button size="small" type="primary" :disabled="disabledOnOff" :loading="loading" class="title" @click="coupouSubmit('editForm')">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
// 导入请求方法
import {
  couponSelectAll,
  insertCoupon,
  delectCoupon,
  insertCouponByPhone,
  grantCoupon,
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import { pcaTextArr } from 'element-china-area-data'

export default {
  data() {
    return {
      disabledOnOff: false, //按钮禁用开关
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '添加用户',
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      unitAccessshow: false, //控制所属单位隐藏与显示
      coupouVisible: false, //控制所属单位隐藏与显示
      isUpdate:false,
      //地区选择
      options: pcaTextArr,
      selectedOptions: [],
      openingRegionArray:[],
      openingRegionOneArray:[],
      //分部
      selectBranchList:[],

      driverlineList:[],

      byBranchList:[],
      // 编辑与添加
      editForm: {
        name: '',
        limitations: '',
        rule: '',
        amount:'',
        type:'',
        illustrate:'',
        distribute:'',
        fixId:'',
        id:'',
        effective:'',
        userPhone:'',
        denom:'',
      },
      // 部门参数
      unitparm: {
        userIds: '',
        deptId: '',
        deptName: ''
      },
      // 选择数据
      selectdata: [],
      // rules表单验证
      rules: {
        name: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur' }
        ],
        userPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        denom: [
          { required: true, message: '请输入金额', trigger: 'blur' }
        ],
        rule: [
          { required: true, message: '请选择优惠券类型', trigger: 'blur' }
        ],
        amount: [
          { required: true, message: '请输入通用金额', trigger: 'blur' }
        ],
        illustrate: [
          { required: true, message: '请输入使用说明使用说明', trigger: 'blur' }
        ],
        limitations: [
          { required: true, message: '请选择优惠券限制', trigger: 'blur' }
        ],
        distribute: [
          { required: true, message: '请选择发放用户', trigger: 'blur' }
        ],
      },

      // 请求数据参数
      formInline: {
        limit: 1,
        page: 10,
        name: '',
        limitations: '',
        rule: '',
        identify:'',
      },
      //用户数据
      userData: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    //关联车辆
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //地区选择
    handleChange (value) {
      console.log(value)
      let adddress = value.join(',');
      // this.editForm.openingRegion = value.join(',');

      var subStr=new RegExp(',','ig');//创建正则表达式对象,不区分大小写,全局查找
      this.editForm.openingRegion=adddress.replace(subStr,"");
    },
    openingRegionOneChange(value){
      console.log('-----',value)
      let adddress = value.join(',');
      // this.editForm.openingRegion = value.join(',');

      var subStr=new RegExp(',','ig');//创建正则表达式对象,不区分大小写,全局查找
      this.editForm.openingRegionOne=adddress.replace(subStr,"");
      // this.editForm.openingRegionOne =value.join(',');
    },
    sample(row, column, cellValue) {
      if (cellValue == '0') {
        return '男'
      } else if (cellValue == '1') {
        return '女'
      } else {
        return '男'
      }
    },
    // 获取数据方法
    getdata(parameter) {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      // 获取用户列表
      console.log('parameter',parameter);
      couponSelectAll(parameter).then(res => {
        console.log('res---',res)
        if (res.status == 200) {
          this.userData = res.data.list;
          // 分页赋值
          this.pageparm.currentPage = this.formInline.limit;
          this.pageparm.pageSize = this.formInline.page;
          this.pageparm.total = res.data.totalRow;
          this.loading = false;
        } else {
          this.$message({
            type: 'info',
            message: res.message
          })

        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.pageSize
      this.formInline.limit =parm.currentPage
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      console.log('this.formInline-----',this.formInline);
      this.getdata(this.formInline)
    },
    handleEdit2: function(inedex,row){
        this.coupouVisible = true;
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      // console.log('row-----',row);
      if (row != undefined && row != 'undefined') {
        this.isUpdate = true;
        this.title = '发放优惠券'
        this.editForm.id =  row.id;

      } else {
        this.isUpdate = false;
        this.title = '添加优惠券'
        this.editForm.phoneNumbe = ''
        this.editForm.name = ''
        this.editForm.password = ''
        this.editForm.placeName = ''
        this.editForm.openingRegion = ''
        this.editForm.openingRegionOne = ''
        this.editForm.vehicleId = ''
        this.editForm.gender = ''
        this.editForm.drivingExperience = ''
      }
    },
    coupouSubmit(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.disabledOnOff=true
          this.loading=true;
          // 请求方法
          insertCouponByPhone(this.editForm)
            .then(res => {
              this.disabledOnOff=false
              this.coupouVisible = false
              this.isUpdate = false;
              console.log('res+++++',res);
              if (res.status==200) {
                this.$message({
                  type: 'success',
                  message: '发放成功！',
                })
                this.getdata(this.formInline);
                this.loading=false;
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.disabledOnOff=false
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })

        } else {
          return false
        }
      })
    },


    // 编辑、添加提交方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
          this.loading=true;
          // 请求方法
          if (this.isUpdate==true){
            grantCoupon(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                this.isUpdate = false;
                console.log('res+++++',res);
                if (res.status==200) {
                  this.$message({
                    type: 'success',
                    message: '发放成功！'
                  })
                  this.getdata(this.formInline)
                  this.loading=false;
                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          }else {
            insertCoupon(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.status==200) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          }

        } else {
          return false
        }
      })
    },

    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'coupouEdit') {
        this.coupouVisible = false
      } else if (dialog == 'unit') {
        this.unitAccessshow = false
      }
    },
    // 删除用户
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          delectCoupon(row.id)
            .then(res => {
              console.log('-----',res)

              if (res.status==200) {
                this.$message({
                  type: 'success',
                  message: '数据已删除!'
                })
                if (this.pageparm.total<=11){
                  this.formInline.limit = 1;
                }
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },

    // 用户详情
    detailUser(index, row) {
      setTimeout(() => {
        this.logining = false
        this.$router.push({ path: 'driverDetail/detail',query:row })
      }, 1000)
    },

    // 刷新缓存
    refreshCache(index, row) {
      userFlashCache(row.userName)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '刷新成功！'
            })
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.message
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('刷新失败，请稍后再试！')
        })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

</style>




// WEBPACK FOOTER //
// src/views/system/coupon.vue